import { jsx as s } from "react/jsx-runtime";
import { createContext as H } from "@chakra-ui/react-utils";
import { forwardRef as l, omitThemingProps as y, useMultiStyleConfig as _, StylesProvider as p, chakra as m, useStyles as S } from "@chakra-ui/system";
import { cx as b, __DEV__ as d } from "@chakra-ui/utils";
import * as x from "react";
import { UtilStyledIcon as C } from "../../utils/utilStyledIcon.mjs";
import { useSubHeader as N } from "./use-subheader.mjs";
const [g, h] = H({
  strict: !0,
  name: "SubHeaderContext",
  errorMessage: "useSubHeaderContext: `context` is undefined. Seems you forgot to wrap SubHeader components in `<SubHeader />`"
}), v = l(
  ({ children: t, ...e }, a) => {
    const n = y(e), r = _("SubHeader", e), u = {
      ...r.subheader
    }, o = N(e), c = {
      ...o
    };
    return /* @__PURE__ */ s(g, { value: c, children: /* @__PURE__ */ s(p, { value: r, children: /* @__PURE__ */ s(
      m.div,
      {
        ref: a,
        __css: u,
        ...o.getSubHeaderProps(n),
        className: b("odi-subHeader", e.className),
        children: t
      }
    ) }) });
  }
);
d && (v.displayName = "SubHeader");
const P = l(
  (t, e) => {
    const { className: a, ...n } = t, r = b("odi-subHeader__title", a), o = {
      ...S().title
    }, { titleId: c, setTitleMounted: i } = h(), f = {};
    return x.useEffect(() => (i(!0), () => i(!1)), [i]), /* @__PURE__ */ s(
      m.h2,
      {
        ref: e,
        className: r,
        id: c,
        __css: o,
        ...f,
        ...n
      }
    );
  }
);
d && (P.displayName = "SubHeader Title");
const I = (t) => {
  const e = S();
  return /* @__PURE__ */ s(
    C,
    {
      customClassname: "odi-card__icon",
      styleConfig: e.icon,
      ...t
    }
  );
};
d && (I.displayName = "SubHeaderIcon");
export {
  v as SubHeader,
  I as SubHeaderIcon,
  P as SubHeaderTitle
};
